module.exports = __webpack_public_path__ + "static/lahli_bites_clean_simple_V2_600x427-6a3a3f07d24b3ce1ab84e06b22dd1c00.png";